import {z} from 'zod';
import {LabelValueSchema} from '@netx/core-next/schema/common';

export const CategoryAutoListItemSchema = LabelValueSchema.pick({
	label: true,
}).extend({
	// we need to move away from these lbvs
	// in our api layer we will be sure to at least parse this to an int
	value: z.number().int().positive(),
});

export type ICategoryAutoListItem = z.infer<typeof CategoryAutoListItemSchema>;
